import { useTechnicalCategoryBookmark } from '@hooks';
import { Order } from '@services';
import { useStore } from '@stores';
import { debounce } from 'lodash';
import { observer } from 'mobx-react';
import React, { useCallback, useMemo } from 'react';
import Presentation from './VehicleHowToDoIt.presentation';

interface IProps {
  order?: Order;
  category: string;
  vin: string;
  setCategory: (category: string) => void;
}

export const VehicleHowToDoIt: React.FC<IProps> = observer(
  ({ order, category, vin, setCategory }) => {
    const { technicalCategoryStore } = useStore();
    const { selectedCategoryId, categories } = technicalCategoryStore;

    const bookmarked = useTechnicalCategoryBookmark(order?.id);

    const onBookmarkClick = useCallback(
      debounce(async () => {
        order &&
          (await technicalCategoryStore.createTechnicalCategoryBookmark({
            technicalCategoryId: selectedCategoryId,
            orderId: order.id,
          }));
      }, 500),
      [technicalCategoryStore, selectedCategoryId, order]
    );

    const onBackClick = useCallback(() => {
      technicalCategoryStore.clearSelectedCategory();
      technicalCategoryStore.clearSubCategories();
    }, [technicalCategoryStore]);

    const technicalCategoryName = useMemo(
      () => categories.find((x) => x.id === selectedCategoryId)?.name,
      [categories, selectedCategoryId]
    );

    return (
      <Presentation
        bookmarked={bookmarked}
        vin={vin}
        category={category}
        showBookmark={!!order}
        technicalCategoryName={technicalCategoryName}
        selectedCategoryId={selectedCategoryId}
        setCategory={setCategory}
        onBookmarkClick={onBookmarkClick}
        onBackClick={onBackClick}
      />
    );
  }
);
